import React, { useMemo } from 'react';
import ResourcedEmoji from '@atlaskit/emoji/resourced-emoji';
import type { EmojiProvider } from '@atlaskit/emoji/types';

type EmojiItemProps = {
	getEmojiProvider: (
		cloudId?: string | null,
		accountId?: string | null,
	) => Promise<EmojiProvider> | null;
	cloudId?: string;
	accountId?: string;
	emoji?: string | null;
	label?: string;
	fallback?: JSX.Element | string;
	fitToHeight?: number;
};

export const EmojiItem = ({
	getEmojiProvider,
	cloudId,
	accountId,
	emoji,
	label,
	fallback,
	fitToHeight,
}: EmojiItemProps): React.JSX.Element => {
	const emojiProvider = useMemo(
		() => (getEmojiProvider ? getEmojiProvider(cloudId, accountId) : undefined),
		[cloudId, accountId, getEmojiProvider],
	);
	if (!emoji || !emojiProvider) {
		return <>{fallback}</>;
	}

	return (
		<ResourcedEmoji
			emojiId={{ id: emoji, shortName: label ?? emoji }}
			emojiProvider={emojiProvider}
			customFallback={fallback}
			fitToHeight={fitToHeight ?? 20}
		/>
	);
};
